module.exports = __webpack_public_path__ + "static/ibanez-halliday_800.83ad0fa9.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/photos/ibanez-halliday_800.jpg
// module id = 641
// module chunks = 0